import type { StackProps } from '@mui/material';
import { Box, Stack } from '@mui/material';
import { NameBanner, Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledStack,
  StyledFirstTitle,
  StyledServiceItem,
  StyledServiceIcon,
  StyledServiceIconWrapper,
  StyledServiceIconBackground,
  StyledServiceTitle,
  StyledServiceDescription,
  StyledSecondTitle,
} from './styles';
import { useCasesData } from './UseCases.data';
import type { UseCaseData } from './UseCases.types';

const ServiceElement = ({ icon, title, description }: UseCaseData) => (
  <StyledServiceItem>
    <StyledServiceIconWrapper>
      <StyledServiceIconBackground>
        <StyledServiceIcon src={icon} alt={title} />
      </StyledServiceIconBackground>
    </StyledServiceIconWrapper>

    <Stack>
      <StyledServiceTitle variant="strong_400">{title}</StyledServiceTitle>

      <StyledServiceDescription variant="regular_300">
        {description}
      </StyledServiceDescription>
    </Stack>
  </StyledServiceItem>
);

export const UseCases = ({ ...props }: StackProps) => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <Box width="100%" mb={8}>
          <NameBanner text="Use Cases" type="section" color="aquamarine" />
        </Box>

        <Stack
          alignItems="flex-start"
          gap={6}
          width="100%"
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between">
          <Stack width={{ xs: '100%', md: '50%', lg: '45%' }}>
            <StyledFirstTitle variant="display_sm">
              {useCasesData.title}
            </StyledFirstTitle>

            <StyledSecondTitle variant="regular_500">
              {useCasesData.subTitle}
            </StyledSecondTitle>
          </Stack>

          <Stack gap={3} width={{ xs: '100%', md: '50%', lg: '55%' }}>
            {useCasesData.items.map((data, index) => (
              <ServiceElement key={index} {...data} />
            ))}
          </Stack>
        </Stack>
      </StyledStack>
    </Section>
  );
};
